import type { UserOptionData } from "@/features/users/utils/toUserOption";

const normalize = (text: string): string =>
  text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

const matchesQuery = (option: UserOptionData, query: string): boolean => {
  const searchable = normalize(`${option.label} ${option.email ?? ""}`);
  return normalize(query)
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .every((word) => searchable.includes(word));
};

/**
 * Puts the current user first in a user picker's options. They're left out when they
 * don't match the search, like any other user, unless the server's results already hold
 * them: its search matches more loosely than this one.
 */
export const pinCurrentUserOption = (
  options: UserOptionData[],
  currentUser: UserOptionData,
  query: string
): UserOptionData[] => {
  const others = options.filter((option) => option.value !== currentUser.value);
  const isInResults = others.length < options.length;
  if (!isInResults && !matchesQuery(currentUser, query)) {
    return others;
  }
  return [currentUser, ...others];
};
